export const WIKI_ITEM_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '730px',
  panelClass: 'wiki-dialog',
  // disableClose: true,
};

export const WIKI_GROUP_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '18.75rem',
  panelClass: 'wiki-group-dialog',
  // disableClose: true,
};
